<template>
  <div>
    <div>
      <div class="row">
        <div class="offset-sm-9 col-sm-3">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              v-model="globalSearch"
              @input="setData()"
            />
            <label for="sizeOptions" class="input-group-text"
              ><font-awesome-icon
                class="my-auto"
                :icon="['fas', 'magnifying-glass']"
            /></label>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="`p-4 border-radius-20 bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 shadow-table p-3 position-relative`"
    >
      <Loading v-if="loadingAnimation" text="Cargando" />
      <table :class="`table table-${getColorMode.background}`">
        <thead>
          <tr>
            <th
              v-for="(value, key) in columns"
              v-bind:key="`table-column-${key}`"
            >
              {{ value.text }}
            </th>
            <th>Acción</th>
          </tr>
          <tr v-if="1 == 0">
            <th
              v-for="(value, key) in columns"
              v-bind:key="`table-filter-column-${key}`"
            >
              <input
                type="text"
                :name="value.name"
                class="form-control"
                autocomplete="off"
              />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="rows.length > 0">
          <tr
            v-for="(row, keyRow) in rows"
            v-bind:key="`table-inner-row-${keyRow}`"
          >
            <td
              v-for="(column, keyColumn) in columns"
              v-bind:key="`table-column-${keyColumn}`"
            >
              {{ row[column.name] }}
            </td>
            <td>
              <router-link
                class="btn btn-primary text-white"
                :to="{ name: editUrl, params: { dataId: row.id } }"
                >Editar</router-link
              >
            </td>
            <td
              v-if="assignRolesUrl"
            >
              <router-link
                class="btn btn-primary text-white"
                :to="{ name: assignRolesUrl, params: { dataId: row.id } }"
                >Asignar roles</router-link
              >
            </td>
            <td
            v-if="disableUser"
            >
              <button
                :class="row.state == 'active' ? 'btn btn-primary text-white' : 'btn btn-secondary text-white'"
                @click="disableSelectedUser(row.id, row.state)"
              >
                <span v-if="row.state == 'active'"> Deshabilitar usuario </span>
                <span v-else> Habilitar usuario </span>
              </button
              >
            </td>
            <td>
              <button
                v-if="downloadReport"
                class="btn btn-primary text-white"
                @click="downloadFileReport(row.id)"
                >Descargar reporte de archivos</button
              >
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center py-5" :colspan="columns.length + 1">
              <span v-if="loading">Buscando...</span>
              <span v-else>No existen datos disponibles</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row mt-4">
      <div class="col-sm-6 d-flex justify-content-start my-auto">
        <div>
          <span class="items-per-page-text mb-0">Items por página:</span>
          <select
            id="sizeOptions"
            v-model="size"
            class="border-secondary mx-2"
            aria-label="Default select example"
            @change="changeSize()"
          >
            <option
              v-for="(value, key) in sizeOptions"
              v-bind:key="`size-select-${key}`"
            >
              {{ value }}
            </option>
          </select>
        </div>
        <p class="table-entries-text mb-0 text-left">
          {{ calcSize }} registros de {{ total }}
        </p>
      </div>
      <div class="col-sm-6">
        <nav aria-label="Paginación">
          <ul class="pagination justify-content-end">
            <span class="mx-4 my-auto items-per-page-text"
              >Página {{ page }} de {{ lastPage }}</span
            >
            <template v-if="page > 1">
              <li class="page-item">
                <a class="page-link" href="javascript:;" @click="page = 1"
                  ><font-awesome-icon :icon="['fal', 'chevrons-left']"
                /></a>
              </li>
              <li class="page-item" aria-current="page">
                <a
                  href="javascript:;"
                  class="page-link"
                  @click="page = page - 1"
                  ><font-awesome-icon :icon="['fal', 'chevron-left']"
                /></a>
              </li>
            </template>
            <template v-else>
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href="javascript:;"
                  tabindex="-1"
                  aria-disabled="true"
                  ><font-awesome-icon :icon="['fal', 'chevrons-left']"
                /></a>
              </li>
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href="javascript:;"
                  tabindex="-1"
                  aria-disabled="true"
                  ><font-awesome-icon :icon="['fal', 'chevron-left']"
                /></a>
              </li>
            </template>
            <li class="page-item active" aria-current="page">
              <span class="page-link">{{ page }}</span>
            </li>
            <template v-if="page < lastPage">
              <li class="page-item" aria-current="page">
                <a
                  href="javascript:;"
                  class="page-link"
                  @click="page = page + 1"
                  ><font-awesome-icon :icon="['fal', 'chevron-right']"
                /></a>
              </li>
              <li class="page-item">
                <a
                  class="page-link"
                  href="javascript:;"
                  @click="page = lastPage"
                  ><font-awesome-icon :icon="['fal', 'chevrons-right']"
                /></a>
              </li>
            </template>
            <template v-else>
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href="javascript:;"
                  tabindex="-1"
                  aria-disabled="true"
                  ><font-awesome-icon :icon="['fal', 'chevron-right']"
                /></a>
              </li>
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href="javascript:;"
                  tabindex="-1"
                  aria-disabled="true"
                  ><font-awesome-icon :icon="['fal', 'chevrons-right']"
                /></a>
              </li>
            </template>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { mapGetters } from "vuex";
export default {
  name: "dataTable",
  props: {
    url: { default: "" },
    editUrl: { default: "" },
    assignRolesUrl: { default: "" },
    downloadReport: { default: false },
    disableUser: { default: false },
    sizeOptions: { type: Array, default: () => [10, 50, 100] },
  },
  components: { Loading },
  data() {
    return {
      rows: [],
      columns: [],
      page: 1,
      size: this.sizeOptions[0],
      total: 0,
      globalSearch: "",
      loading: false,
      loadingAnimation: false,
    };
  },
  mounted() {
    this.setData();
  },
  methods: {
    changeSize() {
      if (this.page == 1) this.setData();
      this.page = 1;
    },
    async setData() {
      let app = this;
      this.rows = [];
      this.loading = true;
      this.axios
        .get(
          `${this.url}?size=${this.size}&page=${this.page}&search=${this.globalSearch}`
        )
        .then((result) => {
          app.rows = result.data.body.data;
          app.total = result.data.body.total;
          app.columns = result.data.body.columns;
          app.loading = false;
        })
        .catch((error) => {
          app.loading = false;
          console.log(error);
        });
    },
    downloadFileReport(Projectid){
      this.loadingAnimation = true
      this.axios
        .get(`reports/last_files_report?project_id=${Projectid}`)
        .then((result) => {
          this.loadingAnimation = false
          this.$swal({
            icon: "success",
            title: "Archivo descargado con éxito",
          })
          const a = document.createElement('a')
          a.href = result.data.url
          a.download = result.data.name
          a.click()
        })
        .catch((error) => {
          console.log(error)
          this.loadingAnimation = false
          this.$swal({
            icon: 'error',
            title: 'Ops! hubo un problema descargando el reporte, intenta más tarde'
          })
        })
    },
    disableSelectedUser(user_id, state){
      let titleText = state == 'active' ? "¿Quieres deshabilitar el usuario? Podrás volverlo a habilitar después" : "¿Quieres volver a habilitar al usuario? Podrá volver a iniciar sesión"
      this.$swal({
        icon: "question",
        title: titleText,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }).then((answer) => {
        if (answer.isConfirmed) {
          this.axios
          .post(`users/${user_id}/disable_user`,{
            state: state
          })
          .then(() => {
            this.setData()
            this.$swal({
              icon: "success",
              title: "Usuario actualizado con éxito",
            })
          })
          .catch((error) => {
            console.log(error);
          });
          
        }
      })
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    lastPage() {
      return Math.ceil(parseFloat(this.total) / parseFloat(this.size));
    },
    calcSize() {
      return this.total < this.size ? this.total : this.size;
    },
  },
  watch: {
    page: {
      handler: function () {
        this.setData();
      },
    },
  },
};
</script>
